import { render, staticRenderFns } from "./Section3.vue?vue&type=template&id=b7c1023e&scoped=true&"
import script from "./Section3.vue?vue&type=script&lang=js&"
export * from "./Section3.vue?vue&type=script&lang=js&"
import style0 from "./Section3.vue?vue&type=style&index=0&id=b7c1023e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c1023e",
  null
  
)

export default component.exports